const MODULES = {
    DRAFT: 'draft',
    SIGNATURE: 'signature',
}

export default MODULES;